import ExportEmployeesModal from 'modules/employees/components/ExportEmployeesModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'

const ExportEmployeesModalPage = () => {
  const onClose = useOnCloseGoToList()

  return <ExportEmployeesModal onClose={onClose} loading={false} />
}

export default ExportEmployeesModalPage
